import postImageURL from './postImageURL'
import fileNameParser from './fileNameParser'
import Placeholder from './Placeholder'

export { postImageURL }
export { fileNameParser }
export { Placeholder }

const imageService = {
  postImageURL,
  fileNameParser,
  Placeholder
}

export default imageService
